import { commonRepository } from "@/repositories/common/common.repository";
import { RootState } from "@/store";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Get Lookup Tables
 */
export const fetchLookupTables = createAsyncThunk(
	"@common/getLookupTables",
	async (forceUpdate: boolean | undefined = false, { getState }) => {
		const state = getState() as RootState;
		if (state.common.lookupTables && !forceUpdate) {
			return {
				error: false,
				data: state.common.lookupTables,
			};
		}
		return await commonRepository.getLookupTables();
	},
);

export const fetchVendors = createAsyncThunk("@common/getVendors", async () => {
	const resp = await commonRepository.getVendors();
	return resp.data;
});
